module.exports = __webpack_public_path__ + "static/media/ic-cplabs-logo.396e80b0.svg";